import { HttpHelper, HttpServiceParams } from 'rbh-merchant-core';
import { envConfig } from '../../../../config';
import { CAT_REQUEST_ID_LIST } from './cat-constant';

class CatServiceClass {
  getCat = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: envConfig.hostname + 'v1/merchant/company-admin/menu-categories',
      id: CAT_REQUEST_ID_LIST.GET_CAT
    });
  }

  postCat = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: envConfig.hostname + 'v1/merchant/company-admin/menu-categories',
      data: params.data,
      id: CAT_REQUEST_ID_LIST.POST_CAT
    });
  }

  patchCat = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: envConfig.hostname + 'v1/merchant/company-admin/menu-categories',
      data: params.data,
      id: CAT_REQUEST_ID_LIST.PATCH_CAT
    });
  }

  deleteCat = async (params: HttpServiceParams) => {
    return await HttpHelper.delete({
      url: envConfig.hostname + 'v1/merchant/company-admin/menu-categories',
      config: { headers: { menuCategoryId: params.data } },
      id: CAT_REQUEST_ID_LIST.DELETE_CAT
    });
  }
}

export const CatService = new CatServiceClass();
